import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import { Upload } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface EmptyFolderStateProps {
  onUploadClick: () => void;
  className?: string;
}

export function EmptyFolderState({ onUploadClick, className }: EmptyFolderStateProps) {
  useLanguage();
  return (
    <section 
      className={cn(
        // Layout
        "flex flex-col items-center justify-center text-center",
        "border border-dashed border-[#E8E8EF] rounded-[14px]",
        "bg-[#FCFCFF]",
        "gap-3.5",
        "mt-6",
        // Padding responsivo
        "py-10 px-4 md:py-[80px]",
        // Transições
        "transition-all duration-300 ease-in-out",
        // Hover
        "hover:border-[#4169E1] hover:bg-[#EFF6FF]",
        className
      )}
    >
      {/* Ícone de pasta */}
      <div className="relative mb-1">
        <svg 
          width="110" 
          height="110" 
          viewBox="0 0 110 110" 
          fill="none" 
          className="opacity-70"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path 
            d="M20 30C20 25.5817 23.5817 22 28 22H45L52 30H82C86.4183 30 90 33.5817 90 38V82C90 86.4183 86.4183 90 82 90H28C23.5817 90 20 86.4183 20 82V30Z" 
            fill="#4169E1" 
            fillOpacity="0.3"
          />
          <path 
            d="M20 30C20 25.5817 23.5817 22 28 22H45L52 30H82C86.4183 30 90 33.5817 90 38V82C90 86.4183 86.4183 90 82 90H28C23.5817 90 20 86.4183 20 82V30Z" 
            stroke="#4169E1" 
            strokeWidth="2"
          />
        </svg>
      </div>
      
      {/* Título */}
      <h2 className="font-semibold text-base text-[#1B1B1F]">
        {translateInterfaceText("Nenhum vídeo encontrado")}</h2>
      
      {/* Descrição */}
      <p className="font-normal text-sm text-[#707070]">
        {translateInterfaceText("Que tal adicionar seu primeiro vídeo aqui?")}</p>
      
      {/* Botão de ação */}
      <Button
        onClick={onUploadClick}
        className={cn(
          "mt-2 flex items-center gap-2",
          "px-[18px] py-2.5",
          "bg-[#007BFF] hover:bg-[#006AE0]",
          "rounded-lg font-medium text-sm",
          "transition-all duration-200",
          "hover:-translate-y-0.5"
        )}
      >
        <Upload className="h-4 w-4" />
        {translateInterfaceText("Adicionar vídeo")}</Button>
    </section>
  );
}
